import { Account } from 'dashboard/models/account';
import { Case } from 'dashboard/models/case';
import { Inquiry } from 'dashboard/models/inquiry';
import { Report } from 'dashboard/models/report';
import { Transaction } from 'dashboard/models/transaction';
import { WorkflowRunStepType } from 'dashboard/models/workflow-step';
import { ApiListRelationship, ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum WorkflowRunStatus {
  Pending = 'pending',
  Completed = 'completed',
  NotApplicable = 'not_applicable',
  Failed = 'failed',
  Errored = 'errored',
  InProgress = 'in_progress',
}

export enum WorkflowRunType {
  Direct = 'direct',
  Case = 'case',
  API = 'api',
  Event = 'event',
  Account = 'account',
  Module = 'module',
}

export const enum WorkflowRunManualResumeOption {
  Resume = 'resume',
  RerunWithLatestVersion = 'rerun',
}

export const WORKFLOW_RUN_TERMINAL_STATES = [
  WorkflowRunStatus.NotApplicable,
  WorkflowRunStatus.Failed,
  WorkflowRunStatus.Errored,
  WorkflowRunStatus.Completed,
];

export interface WorkflowRunAttributes {
  status: WorkflowRunStatus;
  'created-at': string;
  'updated-at': string;
  'completed-at': string;
  'run-type': WorkflowRunType;
  'initial-variables': {
    'trigger-params': {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      fields: Record<string, any>;
    };
  };
  output: Record<string, string | boolean | number | string[]>;
}

export type TriggerObject = Inquiry | Report | Case | Transaction | Account;

export interface WorkflowRunRelationships {
  workflow: ApiRelationship<ApiModel.Workflow>;
  'workflow-version': ApiRelationship<ApiModel.WorkflowVersion>;
  'trigger-object'?:
    | ApiRelationship<ApiModel.Inquiry>
    | ApiRelationship<ApiModel.Report>
    | ApiRelationship<ApiModel.Case>
    | ApiRelationship<ApiModel.Account>
    | ApiRelationship<ApiModel.Transaction>;
  steps: ApiListRelationship<WorkflowRunStepType>;
  creator?: ApiRelationship<ApiModel.User> | ApiRelationship<ApiModel.Event>;
  'child-workflow-runs': ApiListRelationship<ApiModel.WorkflowRun>;
  'parent-workflow-step'?: ApiRelationship<WorkflowRunStepType>;
  'parent-workflow-run'?: ApiRelationship<ApiModel.WorkflowRun>;
}

export type WorkflowRun = ApiResource<
  WorkflowRunAttributes,
  WorkflowRunRelationships,
  ApiModel.WorkflowRun
>;

export type WorkflowRunEvent = ApiResource<
  WorkflowRunAttributes,
  WorkflowRunRelationships,
  ApiModel.WorkflowRun
>;

export interface WorkflowRunsBulkCreateManualMeta {
  workflowId: string;
  objectIds: string[];
}

export interface WorkflowRunsBulkResumeMeta extends WorkflowRunsBulkCreateManualMeta {}
